import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs';
import { errorHandl } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url.utils';

@Injectable({
  providedIn: 'root'
})
export class RoleService {

  constructor(private http: HttpClient) { }

  saveUser(id:any, payload: any) {
      if (id) {
        return this.http.patch(urls.API_URL + urls.ROLES + `/${id}`, payload)
          .pipe(catchError(errorHandl));
      }
    return this.http.post(urls.API_URL + urls.ROLES, payload)
        .pipe(catchError(errorHandl));
  
    }
  
    getRoles(queryParams?: any) {
      // id: any, queryParams: any
      const params = new HttpParams({ fromObject: queryParams});
      return this.http.get(urls.API_URL + urls.ROLES, {params})
        .pipe(catchError(errorHandl));
    }
  
    getRoleById(id: any) {
      return this.http.get(urls.API_URL + urls.ROLES + `/${id}`)
        .pipe(catchError(errorHandl));
    }

  getPermission() {
    return this.http.get(urls.API_URL + urls.PERMISSIONS,)
      .pipe(catchError(errorHandl));
  }

  getTypes() {
    return this.http.get(urls.API_URL + urls.TYPES,)
      .pipe(catchError(errorHandl));
  }
}
